import React from 'react';
import { Box, Typography } from '@mui/material';
import { flexrow } from '../../global';
import { getStatusColors, getStatusLabel } from '../../helpers/statusColors';

interface BadgeStatusProps {
  status: string;
}

export const BadgeStatus: React.FC<BadgeStatusProps> = ({ status }) => {
  const statusColors = getStatusColors(status);
  const label = getStatusLabel(status);



  return (
    <Box style={flexrow} sx={{
      alignItems: 'center',
      backgroundColor: statusColors.backgroundColor,
      padding: '2px 8px',
      borderRadius: '4px'
    }}>
      <Typography variant="body2" color={statusColors.color}>
        {label}
      </Typography>
    </Box>
  );
}; 